/**
 * Fighter names like the design's "SoggyWalrus42": a new player's first name, and the names of
 * league bots (docs/game-design.md §7.1).
 */
const FIRST = ['Angry', 'Sleepy', 'Wobbly', 'Spicy', 'Clumsy', 'Grumpy', 'Tiny', 'Soggy', 'Feral', 'Polite', 'Hungry', 'Sneaky'] as const;
const SECOND = ['Pickle', 'Waffle', 'Goose', 'Muffin', 'Noodle', 'Badger', 'Potato', 'Llama', 'Biscuit', 'Walrus', 'Turnip', 'Pigeon'] as const;

/** A name from `random()` (uniform in [0, 1)): Math.random in the browser, a seeded one for bots. */
export function fighterName(random: () => number): string {
  const pick = <T>(list: readonly T[]): T => list[Math.floor(random() * list.length)]!;
  return `${pick(FIRST)}${pick(SECOND)}${10 + Math.floor(random() * 90)}`;
}
